import { TmProvince } from '../account';

export class TmCartLineRequest {
    ItemEDP: number;
    Quantity: number;
    Customization: string;
    CustomerEdp: number; //to set buyer for the cart
}

export class TmCartInstallmentRequest {
    NoOfInstallments: number;
}

export class TmCartPromocodeRequest {
    Promocode: string;
}

export class TmCartProvincialTaxRequest {
    Province: TmProvince;
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/model/request/cart-request.ts